import { fromJS  } from 'immutable';

export const State = fromJS({
  isPosting: false,
  isPutting: false,
  isPuttingPosition: false,
  errMsg: '',
  currentNoteId: null
});